import React, { PropTypes } from 'react';
import Link from '../../tc-ui/scroll-to/Link';
import { equals, call, cond, always, ifElse, T, merge, has } from 'ramda';
const CompletedIcon = require('../../../../www/images/blue-white-checkmark.svg');
import ImageUpload from '../../image-upload';
import CropDialog from '../../tc-ui/image-crop/image-crop-dialog';

const TopBannerContainer = props => {
  const {
    firstIcon,
    firstText,
    firstIconCompleted,
    secondIcon,
    secondText,
    secondIconCompleted,
    numberOfIcons,
    iconTextArray,
    bannerColor,
    bannerContent,
    bannerHeight,
    anchorFirstIconTo,
    anchorFirstOffset,
    anchorSecondIconTo,
  } = props;

  const standardTextStyle = { color: '#ffffff', fontSize: '14px' };
  const gridCellClass = call(cond([
    [equals(3), always('Grid-cell Grid--1of3')],
    [equals(4), always('Grid-cell Grid--1of4')],
    [equals(0), always('Grid-cell')],
    [T, always('')],
  ]), numberOfIcons);
  const completedIcon = (<img
    src={CompletedIcon}
    height="30px"
  />);

  const displayIcon = (obj) => call(ifElse(
    equals(true),
      () => completedIcon,
    () => call(ifElse(
      equals(true),
        () => (<img
          src={obj.icon}
          height="30px"
        />),
      () => obj.icon
    ), obj.svgIcon)
  ), obj.completed);

  return (
    <div className="Grid top-action-bar" style={{ backgroundColor: bannerColor ? bannerColor : '#1b2936', height: bannerHeight ? bannerHeight : '160px' }}>
      <div className="Grid-cell--center" style={{ width: '50%', textAlign: 'center', margin: '0 auto' }}>
        {
          call(cond([
            [equals(0), () => bannerContent],
            [equals(2), () => {
              return (
                <div>
                  <Link to={anchorFirstIconTo} offset={anchorFirstOffset}>
                    <div style={{ float: 'left', cursor: 'pointer' }}>
                      {firstIconCompleted ? completedIcon : firstIcon}
                      <p style={standardTextStyle}>
                        {firstText}
                      </p>
                    </div>
                  </Link>
                  <Link to={anchorSecondIconTo}>
                    <div style={{ float: 'right', cursor: 'pointer' }}>
                      {secondIconCompleted ? completedIcon : secondIcon}
                      <p style={standardTextStyle}>
                        {secondText}
                      </p>
                    </div>
                  </Link>
                </div>
              );
            }],
            [T, () => {
              return (
                <div className="Grid">
                  {
                    iconTextArray.map((obj, index) => {
                      const getAnchorTag = call(cond([
                        [equals('Add Memberships'), always('#membership')],
                        [equals('Add Marketing Materials'), always('#marketing-materials')],
                        [T, always('')],
                      ]), obj.iconText);
                      const UploadOrAnchor = call(cond([
                        [() => obj.iconText === 'Add Memberships', always('a')],
                        [() => obj.iconText === 'Add Marketing Materials', always('a')],
                        [has('forCropDialog'), () => CropDialog],
                        [T, () => ImageUpload],
                      ]), obj);
                      return (
                        <div key={index} style={{ width: '25%' }}>
                          <div className={gridCellClass} style={{ position: 'relative', overflow: 'hidden', cursor: 'pointer' }}>
                            <UploadOrAnchor types={obj.types} href={getAnchorTag} { ...obj.forCropDialog }>
                              {displayIcon(obj)}
                              <p style={merge(standardTextStyle, { color: obj.completed ? '#ffffff' : '#50c7f9' })}>
                                <span>{obj.completed ? obj.completedText : obj.iconText} </span><br/>
                              </p>
                            </UploadOrAnchor>
                          </div>
                        </div>
                      );
                    })
                  }
                </div>
              );
            }],
          ]), numberOfIcons)
        }
      </div>
    </div>
  );
};

TopBannerContainer.propTypes = {
  firstIcon: PropTypes.object,
  firstText: PropTypes.any,
  firstIconCompleted: PropTypes.bool,
  secondIcon: PropTypes.object,
  secondText: PropTypes.any,
  secondIconCompleted: PropTypes.bool,
  numberOfIcons: PropTypes.number,
  iconTextArray: PropTypes.array,
  bannerColor: PropTypes.string,
  bannerContent: PropTypes.object,
  bannerHeight: PropTypes.string,
  anchorFirstIconTo: PropTypes.string,
  anchorFirstOffset: PropTypes.number,
  anchorSecondIconTo: PropTypes.string,
};

export default TopBannerContainer;



// WEBPACK FOOTER //
// ./src/app/components/profile/profile-top-bar/top-banner.jsx